import { Directive, ElementRef, Inject, OnDestroy, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { themes } from '../Enums/theme.const';
import { ThemeService } from '../Services/theme.service';
import { Subscription } from 'rxjs';
import { themeName } from '../Enums/enums.enum';

@Directive({
  selector: '[appTheme]'
})
export class ThemeDirective implements OnInit, OnDestroy {

  private themeName = themeName.Default.toString();
  private themServiceSubscription: Subscription;
  constructor(private elementRef: ElementRef,
    @Inject(DOCUMENT) private document: any,
    private themService: ThemeService) { }

  ngOnInit() {
    this.updateTheme(this.themeName);
    this.themService.getActiveTheme()
      .subscribe(themesName => {
        this.themeName = themesName;
        this.updateTheme(this.themeName);

      });
  }

  updateTheme(themesName: any) {
    const element = this.elementRef.nativeElement;
    const them = themes[themesName];
    for (const key in them) {
      element.style.setProperty(key, them[key]);
      this.document.body.style.setProperty(key, them[key]);
    }
  }

  ngOnDestroy() {
    if (this.themServiceSubscription) this.themServiceSubscription.unsubscribe();
  }

}
